import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import {DataManager} from "@syncfusion/ej2-data/src/manager";
import {computed} from "vue";
import {
  GridComponent,
  Column,
  EditSettingsModel
} from "@syncfusion/ej2-vue-grids";
import {ColumnModel} from "@syncfusion/ej2-grids/src/grid/models/column";
import {ref} from "vue";
import {CustomAdaptor} from "@/shared/types/CustomAdaptor";
import {gridActionFailure} from "@/shared/services/api";
import {SelectionSettingsModel} from "@syncfusion/ej2-grids/src/grid/base/grid-model";

/*
provide("grid",[Page, Sort, Resize, Filter, Toolbar, ColumnChooser, ExcelExport, ColumnMenu, Reorder,CommandColumn,Edit ])
*/


interface Props {
  dataManager?: DataManager,
  onActionBegin?: (args: any) => void,
  minHeight?: string
  allowFiltering?: boolean | string
  allowPaging?: boolean | string
  allowSelection?: boolean | string
  columns?: ColumnModel[]
  onRowSelected?: (args: any) => void,
  onRowDeselected?: (args: any) => void,
  url?: string,
  data?: any,
  editSettings?: EditSettingsModel,
  selectionSettings?: SelectionSettingsModel,
  onCommandClick?: (args: any) => void,
  width?: string
  height?: string
  hideScroll?: boolean | string,
  allowExcelExport?: boolean | undefined,
  refreshOnMount?:boolean|undefined
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SogGrid',
  props: {
    dataManager: { default: undefined },
    onActionBegin: { type: Function, default: undefined },
    minHeight: { default: undefined },
    allowFiltering: { type: [Boolean, String], default: false },
    allowPaging: { type: [Boolean, String], default: true },
    allowSelection: { type: [Boolean, String], default: true },
    columns: { default: undefined },
    onRowSelected: { type: Function, default: undefined },
    onRowDeselected: { type: Function, default: undefined },
    url: { default: undefined },
    data: { default: undefined },
    editSettings: { default: undefined },
    selectionSettings: { default: undefined },
    onCommandClick: { type: Function, default: undefined },
    width: { default: 'auto' },
    height: { default: '100%' },
    hideScroll: { type: [Boolean, String], default: false },
    allowExcelExport: { type: Boolean, default: false },
    refreshOnMount: { type: Boolean, default: true }
  },
  emits: ["selected"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props

const _emit = __emit

const grid = ref<InstanceType<typeof GridComponent> | null>(null)
const _adaptor = new CustomAdaptor()
const _dataRefresh = ref<any|undefined>(undefined)

function p_onRowSelected(args: any) {
  _emit("selected", args.data)
  if (props.onRowSelected) {
    props.onRowSelected(args)
  }
}

function p_onRowDeselected(args: any) {
  if (args.isInteracted) {
    _emit("selected", undefined)
  }
  if (props.onRowDeselected) {
    props.onRowDeselected(args)
  }
}


//setCulture('de');


const _dataFromProps = computed(() => {
  if (props.url) {
    return new DataManager({
      url: props.url,
      adaptor: _adaptor,
      crossDomain: true,
      requestType: 'POST'
    })
  } else if (props.dataManager) {
    return props.dataManager
  } else if (props.data) {
    return ref(props.data)
  }
  return undefined
})


const _data = computed(() => {
  if(props.refreshOnMount){
    return _dataFromProps.value
  }
  return _dataRefresh.value
})


function p_onActionBegin(args: any) {
  if (args.requestType === 'filtersearchbegin') {
    _adaptor.filterSearch = true
  }
}

function dataBound() {
  if (props.hideScroll)
    grid.value?.hideScroll();
}

const pageSettings = {pageSize: 50, pageSizes: ["All", 10, 25, 50, 100]}
//const  sortSettings = { columns: [{ field: 'entryDate', direction: 'Descending' }] }
const filterSettings = {type: 'Menu'}  //Menu CheckBox FilterBar Excel
//const  selectionSettings = { type: 'Multiple' }

const _style = computed(() => {
  return props.minHeight ? "min-height: " + props.minHeight : ""
})

const _allowPaging = computed(() => {
  return props.allowPaging === "true" ? true : props.allowPaging === "false" ? false : props.allowPaging
})

function toolbarClick(args: any) {
  if (args.item.id === 'gridRestore') {
    clickRestore()
    return
  }
}

function refreshColumns() {
  grid.value?.refreshColumns()
}

function refresh() {
  if(!props.refreshOnMount && !(_dataRefresh.value)){
    _dataRefresh.value = _dataFromProps.value
  }
  grid.value?.refresh()
}

function excelExport() {
  grid.value?.excelExport()
}


function hideColumns(keys: string | string[]) {
  grid.value?.hideColumns(keys)
}

function showColumns(keys: string | string[]) {
  grid.value?.showColumns(keys)
}


function clickRestore(): void {
  /*
      const grid: any = $refs.grid
    grid.ej2Instances.enablePersistence = false
    window.localStorage.setItem('gridBatch', '')
    grid.ej2Instances.destroy()
    location.reload()
  */
}

/*
function actionFailure(args:any){
  console.log(args);
  let f = undefined
  if(args.error?.error?.status === 401) {
    f = apiAuth.logout
  }
  notificationService.error(args.error?.error.responseText,f)
}
*/


function onActionComplete() { //actionComplete-Ereignis von Grid
  /*
    console.log(args.requestType);
    if (args.requestType === "filterafteropen") {
      // Bedingung wird ausgeführt, nachdem der Filterdialog geöffnet wurde
      // Abrufen der aktuellen Position des Filterdialogs
      var dlgPosition = args.filterModel.dialogObj.element.getBoundingClientRect();
      // Dokumentkörper wird als Ziel des Filterdialogs festgelegt
      args.filterModel.dialogObj.target = document.getElementsByTagName("BODY")[0];
      // Die ursprünglich abgerufene Dialogposition wird als Filterdialogposition gesetzt
      args.filterModel.dialogObj.position.X = dlgPosition.x+100;
      args.filterModel.dialogObj.position.Y = dlgPosition.y;
      // Der Filterdialog wird aktualisiert, um die Änderungen zu aktualisieren
      args.filterModel.dialogObj.refresh();
    }
  */
}


function getColumnByField(field: string): Column | undefined {
  return grid.value?.getColumnByField(field) as Column
}

function _commandClick(args: any) {
  if (props.onCommandClick)
    props.onCommandClick(args)
}

__expose({
  hideColumns, refresh, adaptor: _adaptor, refreshColumns, showColumns, getColumnByField, excelExport
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_unref(GridComponent), {
      ref_key: "grid",
      ref: grid,
      "data-source": _data.value,
      columns: __props.columns,
      "page-settings": pageSettings,
      "allow-paging": _allowPaging.value,
      "allow-sorting": true,
      "allow-multi-sorting": true,
      "allow-filtering": __props.allowFiltering,
      "filter-settings": filterSettings,
      height: __props.height,
      "show-column-chooser": "true",
      "toolbar-click": toolbarClick,
      "enable-persistence": false,
      width: __props.width,
      "allow-reordering": true,
      "allow-resizing": true,
      "show-column-menu": false,
      "action-begin": p_onActionBegin,
      "action-complete": onActionComplete,
      "allow-text-wrap": true,
      style: _normalizeStyle(_style.value),
      "row-selected": p_onRowSelected,
      "row-deselected": p_onRowDeselected,
      "action-failure": _unref(gridActionFailure),
      "edit-settings": __props.editSettings,
      "selection-settings": __props.selectionSettings,
      "command-click": _commandClick,
      "enable-sticky-header": "true",
      "data-bound": dataBound,
      "allow-selection": __props.allowSelection,
      "allow-excel-export": __props.allowExcelExport
    }, {
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["data-source", "columns", "allow-paging", "allow-filtering", "height", "width", "style", "action-failure", "edit-settings", "selection-settings", "allow-selection", "allow-excel-export"])
  ]))
}
}

})